module.exports = __webpack_public_path__ + "static/media/underExampleMoney.b4cfd9b1.png";